module.exports = __webpack_public_path__ + "img/tu_file_jpg.31b200a5.svg";